import React, { Fragment, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import { setActiveTab } from '../../redux/actions/routing';
import Routes from '../../components/routes/Routes';
import Dropdown from '../../components/dropdown/Dropdown';
import {
  StateModel,
  StateModel_Benutzererfassung,
  StateModel_Modal,
} from '../../redux/store';
import {
  getClientConfig,
  logout,
  revertSession,
} from '../../redux/actions/login';
import { setModalConfig } from '../../redux/actions/modal';
import Modal from '../../components/modal/Modal';
import Notification from '../notification/Notification';
import { setNotificationField } from '../../redux/actions/notification';
import Button from '../../components/button/Button';
import { fetchTranslations } from '../../redux/actions/translation';
import { Auth } from '../../api';
import { nameof } from '../../utils/objectUtils';
import Benutzererfassung from '../tms/benutzererfassung/Benutzererfassung';
import { removeNotifications } from '../../utils/notificationUtils';
import { setBenutzerValue } from '../../redux/actions/benutzererfassung';
import { setLoading } from '../../redux/actions/spinner';
import Spinner from '../../components/spinner/Spinner';
import { ConfigModel } from '../../models/ConfigModel';

interface MainProps {
  activeTab: string;
  setActiveTab: (value: string) => void;
  isAuthenticated: boolean;
  logout: () => void;
  modal: StateModel_Modal;
  setModalConfig: (value: any, fieldName: string) => void;
  fetchTranslations: () => void;
  accessToken?: string;
  refreshToken?: string;
  isAdmin: boolean;
  isAuftragEdit: boolean;
  setBenutzerValue: (
    value: string | number | undefined,
    fieldName: string
  ) => void;
  setNotificationField: (value: any, fieldName: string) => void;
  auth: Auth;
  loading: boolean;
  setLoading: (value: boolean) => void;
  wasAdmin: boolean;
  revertSession: () => void;
  getClientConfig: () => void;
  config: ConfigModel;
}

export interface DropdownList {
  [p: string]: boolean;
}

/**
 * Main-Component
 * dient zur Darstellung des Arbeitsbereiches mit den Anwendungstabs und entsprechenden Screens als Content,
 * z.B. der Auftragserfassung
 *
 * @returns {JSX.Element} Main-Component
 * @constructor
 */
const Main = (props: MainProps) => {
  const [showModalEdit, setShowModalEdit] = useState(false);
  const [benutzerId, setBenutzerId] = useState(-1);
  const [benutzerName, setBenutzerName] = useState('NN');

  useEffect(() => {
    setBenutzerId(props.auth.userID == undefined ? -1 : +props.auth.userID);
    setBenutzerName(props.auth.username ?? 'NN');
  }, [props.auth.userID]);

  const location = useLocation();
  useEffect(() => {
    props.setActiveTab(location.pathname.split('/')[1]);
  }, [location]);

  const [isListOpen, setIsListOpen] = useState<DropdownList>({
    list1: false,
    list2: false,
  });

  const onClick = (selectedTab: string) => {
    props.setNotificationField(undefined, 'activeComponent');
    removeNotifications();
    props.setActiveTab(selectedTab);
    setIsListOpen({ ...isListOpen, [selectedTab]: false });
  };

  const onEditBenutzer = () => {
    if (benutzerId > -1) {
      props.setBenutzerValue(
        benutzerId,
        nameof<StateModel_Benutzererfassung>('id')
      );
      openBenutzererfassung();
    }
  };

  /**
   * Steuert die Schliessung vom Modalen Fenster und leert den State der Felder.
   */
  const handleClose = () => {
    setShowModalEdit(false);
  };

  const openBenutzererfassung = () => {
    setShowModalEdit(true);
  };

  const hilfe = () => {
    const a = document.createElement('a');
    a.setAttribute('hidden', '');
    a.setAttribute('href', '../Handbuch.pdf');
    a.setAttribute('target', '_blank');
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };
  let auftragedit = props.isAuftragEdit;
  if (props.config.denyOrderEdit) {
    auftragedit = false;
  }

  return (
    <div className='main'>
      {props.isAuthenticated && props.config.loaded && (
        <div className='work-tabs'>
          <Dropdown
            label='Auftragsmanagement '
            selectedTab='auftragsmanagement'
            icon='dropdown-arrow fas fa-angle-down'
            classes={`menu ${
              props.activeTab === 'auftragsmanagement' ? 'active' : ''
            }`}
            isListOpen={isListOpen}
            setIsListOpen={setIsListOpen}
          >
            {auftragedit && (
              <Link to='/auftragsmanagement/auftragserfassung'>
                <button onClick={() => onClick('auftragsmanagement')}>
                  Auftragserfassung
                </button>
              </Link>
            )}

            <Link to='/auftragsmanagement/auftragsresearch'>
              <button onClick={() => onClick('auftragsmanagement')}>
                Auftragsliste
              </button>
            </Link>
            {auftragedit && (
              <Link to='/auftragsmanagement/offeneauftraege'>
                <button onClick={() => onClick('auftragsmanagement')}>
                  offene Aufträge
                </button>
              </Link>
            )}
            {auftragedit && (
              <Link to='/auftragsmanagement/auftragsvorlagen'>
                <button onClick={() => onClick('auftragsmanagement')}>
                  Auftragsvorlagen
                </button>
              </Link>
            )}
            <Link to='/auftragsmanagement/auftragsexport'>
              <button onClick={() => onClick('auftragsmanagement')}>
                Monatlicher CSV-Export
              </button>
            </Link>
          </Dropdown>
          <Dropdown
            label='Benutzer-Daten '
            selectedTab='masterdata'
            icon='dropdown-arrow fas fa-angle-down'
            classes={`menu ${props.activeTab === 'masterdata' ? 'active' : ''}`}
            isListOpen={isListOpen}
            setIsListOpen={setIsListOpen}
          >
            {auftragedit && (
              <Link to='/masterdata/adressmanagement'>
                <button onClick={() => onClick('masterdata')}>
                  Adressenmanagement
                </button>
              </Link>
            )}
            <Link to='/masterdata/usermanagement'>
              <button onClick={() => onClick('masterdata')}>
                Benutzermanagement
              </button>
            </Link>
          </Dropdown>

          {props.isAdmin && (
            <Fragment>
              <Link className={'adminbereich'} to='/admin'>
                <Button onClickHandler={() => onClick('admin')}>
                  <i className='fas fa-user-ninja fa-2x' />
                  <span className={'buttontextspan'}>Adminbereich</span>
                </Button>
              </Link>
              <Button
                classes={'useredit'}
                tooltip={
                  'als ' +
                  benutzerName +
                  ' mit  Administratorrechten angemeldet'
                }
                onClickHandler={() => onEditBenutzer()}
              >
                <i className='fas fa-user-ninja fa-2x'></i>
                <span className={'buttontextspan'}>{benutzerName}</span>
              </Button>
            </Fragment>
          )}

          {!props.isAdmin && (
            <Button
              classes={'useredit'}
              onClickHandler={() => onEditBenutzer()}
              tooltip={'als Benutzer ' + benutzerName + ' angemeldet'}
            >
              <i className='fas fa-user fa-2x'></i>
              <span className={'buttontextspan'}>{benutzerName}</span>
            </Button>
          )}
          {props.wasAdmin && (
            <Link className={'logout'} to='/'>
              <Button onClickHandler={() => props.revertSession()}>
                <i className='fas fa-sign-out-alt fa-2x' /> &nbsp;
                Benutzerwechsel
              </Button>
            </Link>
          )}
          {!props.isAdmin && <i className='fas fa-user fa-2x'></i>}
          <Link className={'logout'} to='/'>
            <Button onClickHandler={() => hilfe()}>
              <i className='fas fa-question-circle fa-2x' />{' '}
              <span className={'buttontextspan'}>Hilfe</span>
            </Button>
          </Link>
          <Link className={'logout'} to='/'>
            <Button onClickHandler={() => props.logout()}>
              <i className='fas fa-sign-out-alt fa-2x' />{' '}
              <span className={'buttontextspan'}>Logout</span>
            </Button>
          </Link>
        </div>
      )}
      <Routes />
      <Modal
        show={props.modal.config?.show}
        closeHandler={() => props.setModalConfig(false, 'show')}
        closeByOutsideClick={false}
        titel={props.modal.config?.title ?? ''}
        height={props.modal.config?.height}
        width={props.modal.config?.width}
        description={props.modal.config?.description}
      >
        {props.modal.config?.children}
      </Modal>
      <Modal
        show={showModalEdit}
        closeHandler={handleClose}
        closeByOutsideClick={false}
        titel={
          props.auth.userID ? 'Benutzer bearbeiten' : 'Benutzer hinzufügen'
        }
        height={props.auth.userID ? '385px' : '350px'}
        width={'500px'}
      >
        <Benutzererfassung close={handleClose} />
      </Modal>
      <Spinner setIsLoading={props.setLoading} isLoading={props.loading} />
      <Notification />
    </div>
  );
};

const mapStateToProps = (state: StateModel) => ({
  activeTab: state.Routing.activeTab,
  isAuthenticated: !!state.Auth.accessToken,
  modal: state.Modal,
  auth: state.Auth,
  isAdmin: state.UserSession.isAdmin,
  isAuftragEdit: state.UserSession.isAuftragEdit,
  wasAdmin: !!state.Auth.backupToken,
  loading: state.Loading.loading,
  config: state.Config,
});

export default connect(mapStateToProps, {
  setActiveTab,
  logout,
  setModalConfig,
  fetchTranslations,
  setNotificationField,
  setBenutzerValue,
  revertSession,
  setLoading,
  getClientConfig,
})(Main);
